import Vue from 'vue'
import store from '@/store/'
import VueNativeSock from 'vue-native-websocket'
import { WEBSOCKER_METHODS } from '@/store/mutation-types'

// 本地 ws://192.168.0.155:9292
// 线上 wss://yun-api.nianchu.net:9292
// 备用 wss://yun-api95d.nianchu.net:9292

// ws://service-l32jwald-1301483065.sh.apigw.tencentcs.com:80
// wss://service-l32jwald-1301483065.sh.apigw.tencentcs.com:443

Vue.use(VueNativeSock, 'wss://yun-api95d.nianchu.net', {
    connectManually: true,  //开启手动连接，在初始化BasicLayout.vue组件时进行连接手动连接this.$connect()
    reconnection: true, // (Boolean) whether to reconnect automatically (false)
    reconnectionAttempts: 5, // (Number) number of reconnection attempts before giving up (Infinity),
    reconnectionDelay: 3000, // (Number) how long to initially wait before attempting a new (1000)
    store: store,
    mutations: WEBSOCKER_METHODS,
    passToStoreHandler: function (eventName, event) {
        if (!eventName.startsWith('SOCKET_')) { return }
        let method = 'commit'
        let target = eventName.toUpperCase()
        let msg = event
        if (this.format === 'json' && event.data) {
            try {
                msg = JSON.parse(event.data)
                // 判断是否机器人消息
                if (msg.contents && msg.sub_id) {
                    this.store['dispatch']('WEBSOCKER_ACTIONS_ONCHATMSG', msg)
                }
                // 判断来自服务器的消息
                if (msg.client && msg.client == "system") {
                    this.store['dispatch']('WEBSOCKER_ACTIONS_ONSERVERMSG',msg.operator_params)
                }
                if(msg.code===10003){
                    this.store['commit']('WEBSOCKER_MUTATIONS_ERROR',msg)
                }
            } catch (error) {
                console.log('websocket',event.data)
            }
        }
        this.store[method](target, msg)
    },
    format: 'json'
})


// passToStoreHandler: function (eventName, event) {
//     if (!eventName.startsWith('SOCKET_')) { return }
//     let method = 'commit'
//     let target = eventName.toUpperCase()
//     let msg = event
//     if (this.format === 'json' && event.data) {
//         msg = JSON.parse(event.data)
//         if (msg.mutation) {
//             target = [msg.namespace || '', msg.mutation].filter((e) => !!e).join('/')
//         } else if (msg.action) {
//             method = 'dispatch'
//             target = [msg.namespace || '', msg.action].filter((e) => !!e).join('/')
//         }
//     }
//     this.store[method](target, msg)
// }